import React, { forwardRef, SVGProps, useState } from "react";
import DownIcon from "../../img/Down.svg?react";
import "./NetworkDropdown.css";
import { NetworkButtonStyled } from "./elements/NetworkButtonStyled";
import { GlobalStore } from "../../store/global/GlobalStore";
import { motion } from "framer-motion";
import { CHAINS } from "config/chains";
import styled from "@emotion/styled";
import { Text } from "../general/Text";

export interface NetworkButtonProps {
  networkIconColor: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  id: number;
  onClick?: () => void;
  isDropdownOpen: boolean;
}

export const NetworkButton = forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<NetworkButtonProps>
>((props, ref) => {
  const Icon = props.icon;
  const theme = GlobalStore.useState(s => s.theme);
  const [showNetworkName, setShowNetworkName] = useState(false);

  return (
    <NetworkButtonStyled
      theme={theme}
      isDropdownOpen={props.isDropdownOpen}
      data-testid={"network-button"}
      onClick={props.onClick}
      onMouseEnter={() => setShowNetworkName(true)}
      onMouseLeave={() => setShowNetworkName(false)}
      ref={ref}
    >
      <Icon width={24} height={24} color={props.networkIconColor} />
      <NameAndDownIconContainer>
        <NetworkName
          initial={false}
          animate={{
            width: showNetworkName ? "auto" : 0,
            opacity: showNetworkName ? 1 : 0,
            transition: { duration: 0.3 },
          }}
        >
          <Text size="Medium" textStyle="Button" style={{ textWrap: "nowrap" }}>
            {CHAINS[props.id].displayName}
          </Text>
        </NetworkName>
        <StyledDownIcon width={20} height={20} stroke={"white"} />
      </NameAndDownIconContainer>
      {props.children}
    </NetworkButtonStyled>
  );
});

const NameAndDownIconContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 2px;
`;
const NetworkName = styled(motion.div)`
  width: 0;
  overflow: hidden;
`;

const StyledDownIcon = styled(DownIcon)`
  z-index: 1.5;
`;
